/* import __COLOCATED_TEMPLATE__ from './verification-failed.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();